module.exports = __webpack_public_path__ + "img/13.2a36565f.jpg";